import React from "react";
// import { StaticImage } from "gatsby-plugin-image";
import FigureCover from "../FigureCover";
// import styled from "styled-components";

import template1Graphique1 from "../../images/template1-graphique-1.svg";
import template1Graphique2 from "../../images/template1-graphique.svg";
import template1Graphique3 from "../../images/template1-graphique-3.svg";

// const TraitDeCoupe = styled.div`
//   width: 34px;
//   height: 34px;
//   position: absolute;
//   &:before,
//   &:after {
//     content: "";
//     position: absolute;
//     background: red;
//   }
//   &:before {
//     width: 1px;
//     height: 27px;
//   }
//   &:after {
//     width: 27px;
//     height: 1px;
//     bottom: 0;
//     right: 0;
//   }
// `;

// const NorthEast = styled(TraitDeCoupe)`
//   top: var(--headerHeight);
//   right: 0;
// `;
// const SouthEast = styled(TraitDeCoupe)`
//   bottom: 0;
//   right: 0;
//   transform: rotate(90deg);
// `;
// const NorthWest = styled(TraitDeCoupe)`
//   top: var(--headerHeight);
//   left: 0;
//   transform: rotate(-90deg);
// `;
// const SouthWest = styled(TraitDeCoupe)`
//   bottom: 0;
//   left: 0;
//   transform: rotate(180deg);
// `;

const PC1 = ({ input }) => (
  <div className='template1'>
    {/* <Pre input={input} /> */}
    {input && (
      <div
        className=' h-screen flex'
        style={{
          display: ""
          // gridTemplateColumns: "10.5% 12.4% auto"
        }}>
        <div className='image1 h-full' style={{ maxWidth: "10.5%" }}>
          {input[0] && <FigureCover input={input[0]} />}
          {/* <NorthEast />
          <SouthEast /> */}

          <div className='pt-25 absolute h-full top-0 right-0 z-10'>
            <img
              src={template1Graphique1}
              alt='template1Graphique1'
              className='h-full'
            />
          </div>
        </div>
        <div
          className='deco h-full pt-25 flex-shrink-0 z-10'
          style={
            {
              // marginLeft: "-34px",
              // marginRight: "-34px",
              // zIndex: 2
            }
          }>
          {/* <StaticImage
            src='../../images/template1-graphique.svg'
            alt='template1 graphique'
            className='h-full'
            placeholder='blurred'
          /> */}
          <img
            src={template1Graphique2}
            alt='template1 graphique'
            className='h-full'
          />
        </div>
        <div className='image2 h-full '>
          {input[1] && <FigureCover input={input[1]} />}
          <div className='pt-25 absolute h-full top-0 left-0 z-10'>
            <img
              src={template1Graphique3}
              alt='template1Graphique3'
              className='h-full'
            />
          </div>
        </div>
      </div>
    )}
  </div>
);

export default PC1;
